export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_FEEDING_GUIDELINES_GENERATE_ACTION';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_FEEDING_GUIDELINES_GENERATE_ACTION';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_FEEDING_GUIDELINES_GENERATE_ACTION';
export const DEFAULT = 'DEFAULT_FEEDING_GUIDELINES_GENERATE_ACTION';
export const DISPLAY_FEEDING_GUIDELINES = 'DISPLAY_FEEDING_GUIDELINES_FEEDING_GUIDELINES_GENERATE_ACTION';
export const HIDE_FEEDING_GUIDELINES = 'HIDE_FEEDING_GUIDELINES_FEEDING_GUIDELINES_GENERATE_ACTION';
export const SET_NOTES = 'SET_NOTES_FEEDING_GUIDELINES_GENERATE_ACTION';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
